import { put, call, takeEvery } from "redux-saga/effects"
import { post as postApi } from "api"
import { createActions } from "reduxsauce"

export const { Types, Creators } = createActions({
  checkAuthType: ["email", "successAction"],
}, {
  prefix: "ompnt/modules/token/",
})

function* checkAuthType({ email, successAction }) {
  const authType = yield call(postApi, "/auth", { email })
  yield put(successAction(authType))
}

export function* saga() {
  yield takeEvery(Types.CHECK_AUTH_TYPE, checkAuthType)
}
